export default "__VITE_ASSET__8e063400__"